import DashboardView from '@/views/Dashboard/DashboardView.vue'
import HomeView from '@/views/Base/HomeView.vue'
import LoginView from '@/views/Authentication/LoginView.vue'
import ServersView from '@/views/Dashboard/ServersView.vue'
import AdminServersView from '@/views/Admin/AdminServersView.vue'
import { createRouter, createWebHistory } from 'vue-router'
import AdminUsersView from '@/views/Admin/AdminUsersView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/servers',
    name: 'Servers',
    component: ServersView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView
  },
  {
    path: '/admin/servers',
    name: 'Admin Servers',
    component: AdminServersView
  },
  {
    path: '/admin/users',
    name: 'Admin Users',
    component: AdminUsersView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
